import React from "react";
import "./CallMeDialog.css";

const CallMeDialog = ({ open, onClose }) => {
  if (!open) return null;

  return (
    <div className="dialog-backdrop">
      <div
        className="dialog-container"
      >
        <h2 className="dialog-title">Request a Call Back</h2>

        <div className="dialog-body">
          <input
            type="text"
            placeholder="Name"
            className="dialog-input"
          />

          <input
            type="tel"
            placeholder="Mobile"
            className="dialog-input"
          />

          <textarea
            placeholder="Describe your problem"
            className="dialog-textarea"
          ></textarea>

          <button className="dialog-button">
            Call Me
          </button>
        </div>
      </div>
    </div>
  );
};

export default CallMeDialog;
